/* Mission Beard — scent collection pages.
   1. Mix & match ladder: [data-mb-scent-add="id,id,…"] adds every variant in one
      /cart/add.js call, then opens the Opus cart drawer (same as mb-plp.js).
   2. Best-sellers carousel arrows: scroll the track by one card.
   3. Jump bar: highlight the pill that was tapped. */
(function () {
  'use strict';
  if (window.__mbScentInit) return;
  window.__mbScentInit = true;

  function ready(fn) {
    if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    /* 0. Time-boxed promo text: re-check against the visitor's clock (pages can be cached) */
    document.querySelectorAll('[data-mb-window]').forEach(function (el) {
      var w = (el.getAttribute('data-mb-window') || '').split(',');
      var now = Date.now() / 1000;
      var on = now >= +w[0] && now <= +w[1];
      var inEl = el.hasAttribute('data-in') ? el : el.querySelector('[data-in]');
      var outEl = el.querySelector('[data-out]');
      if (inEl) inEl.style.display = on ? '' : 'none';
      if (outEl) outEl.style.display = on ? 'none' : '';
    });

    /* 1. Ladder add */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mb-scent-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      var ids = (btn.getAttribute('data-mb-scent-add') || '').split(',').map(function (v) { return parseInt(v, 10); }).filter(Boolean);
      if (!ids.length) return;
      var idle = btn.getAttribute('data-idle') || btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (res) {
          return res.json().then(function (body) {
            if (!res.ok) throw new Error(body.description || body.message || 'Could not add to cart.');
            return body;
          });
        })
        .then(function () {
          btn.disabled = false;
          btn.classList.add('is-added');
          btn.textContent = 'Added';
          if (typeof window.opusRefreshCart === 'function') window.opusRefreshCart();
          if (typeof window.opusOpen === 'function') {
            window.opusOpen();
          } else {
            document.dispatchEvent(new CustomEvent('instant:add-to-cart'));
          }
          setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = idle; }, 4000);
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.textContent = idle;
          if (window.console) console.error('[mb-scent]', err);
          window.location.href = '/cart';
        });
    });

    /* 2. Carousel arrows */
    document.querySelectorAll('.mb-bs').forEach(function (sec) {
      var track = sec.querySelector('[data-mb-bs-track]');
      var prev = sec.querySelector('[data-mb-bs-prev]');
      var next = sec.querySelector('[data-mb-bs-next]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.querySelector('.mb-plp-card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      }
      function sync() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });

    /* 3. Jump bar: sit under the sticky site header */
    var head = document.getElementById('shopify-section-mb-header');
    function setHead() {
      var pos = head ? getComputedStyle(head).position : '';
      var h = (pos === 'sticky' || pos === 'fixed') ? head.offsetHeight : 0;
      document.documentElement.style.setProperty('--mb-head-h', h + 'px');
    }
    setHead();
    window.addEventListener('resize', setHead);

    document.querySelectorAll('.mb-scent-jump').forEach(function (bar) {
      var links = bar.querySelectorAll('[data-mb-jump]');
      if (links[0]) links[0].classList.add('is-on');
      links.forEach(function (a) {
        a.addEventListener('click', function () {
          links.forEach(function (l) { l.classList.remove('is-on'); });
          a.classList.add('is-on');
        });
      });
    });
  });
})();
